import { createContext, useContext, type ReactNode } from 'react';

/** Innerhalb eines Dashboard-Moduls bringt das Raster Rahmen und Überschrift bereits mit. */
export const InModuleContext = createContext(false);

export function Seal({ number, dead, mayor }: { number: number; dead?: boolean; mayor?: boolean }) {
  return (
    <span className={`seal${dead ? ' dead' : ''}${mayor ? ' mayor' : ''}`} aria-hidden="true">
      {number}
    </span>
  );
}

export function Panel({ title, aside, children }: { title?: string; aside?: ReactNode; children: ReactNode }) {
  const inModule = useContext(InModuleContext);
  if (inModule) {
    return (
      <>
        {aside && <div className="panel-aside">{aside}</div>}
        {children}
      </>
    );
  }
  return (
    <section className="panel">
      {title && (
        <header>
          <h2>{title}</h2>
          {aside}
        </header>
      )}
      {children}
    </section>
  );
}

export function Notice({
  children,
  calm,
  danger,
}: {
  children: ReactNode;
  calm?: boolean;
  danger?: boolean;
}) {
  return <div className={`notice${calm ? ' calm' : ''}${danger ? ' danger' : ''}`}>{children}</div>;
}

export function CameraDot({ status }: { status: 'NONE' | 'CONNECTING' | 'LIVE' | 'ERROR' }) {
  const cls = status === 'LIVE' ? 'live' : status === 'CONNECTING' ? 'warn' : status === 'ERROR' ? 'off' : '';
  const label = { NONE: 'Keine Kamera', CONNECTING: 'Kamera verbindet', LIVE: 'Kamera läuft', ERROR: 'Kamera gestört' }[
    status
  ];
  return <span className={`dot ${cls}`} title={label} aria-label={label} role="img" />;
}

/** Auswahl eines Spielers – bewusst als Knöpfe, damit es auf dem Handy gut trifft. */
export function TargetPicker({
  players,
  allowed,
  value,
  onChange,
  disabled,
}: {
  players: { id: string; number: number; name: string }[];
  allowed: string[];
  value: string | null;
  onChange: (id: string) => void;
  disabled?: boolean;
}) {
  const choices = players.filter((p) => allowed.includes(p.id));
  if (choices.length === 0) return <p className="muted">Niemand steht zur Wahl.</p>;
  return (
    <div className="grid-two">
      {choices.map((p) => (
        <button
          key={p.id}
          type="button"
          className={value === p.id ? 'selected' : ''}
          disabled={disabled}
          onClick={() => onChange(p.id)}
        >
          {p.name}
        </button>
      ))}
    </div>
  );
}
